import {v4 as uuidv4} from "uuid";

export default function getProducts(room, austattung_produkt, selectedAlternatives, existingActions, lang='de', subProjectType='umbau'){

    const productList = [];
    let actions = [];
    let combinations = {
        name: room.name,
        combinations: [],
        producte: [],
        producte_sch_d: []
    };
    const productList_optional = [];

    function getNewUuid() {
        const uuid = uuidv4();
        let found = actions.filter(i => i.uuid === uuid)[0] !== undefined;
        if (found) { return getNewUuid(); }
        found = existingActions.filter(i => i.uuid === uuid)[0] !== undefined;
        if (found) { return getNewUuid(); }
        return uuid;
    }
    function addActionForDevice(device, item, nr) {
        const retList = [];
        for (let i = 0; i < nr; i++) {
            switch (item.key) {
                case "schaltbare_beleuchtung": //switch_light
                    const nAction = {type: 'switch_light', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nAction); retList.push(nAction);
                    break;
                case "schaltbare_steckdosen": //switch_powerplug
                    const nActionp = {type: 'switch_powerplug', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActionp); retList.push(nActionp);
                    break;
                case "steckdosen-eneg": //switch_powerplug home
                    const nActionpp = {type: 'switch_powerplug', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActionpp); retList.push(nActionpp);
                    break;
                case "steckdosen-home": //switch_powerplug home
                    const nActionppp = {type: 'switch_powerplug', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActionppp); retList.push(nActionppp);
                    break;
                case "dimmbare_beleuchtung": //dim
                    const nActiond = {type: 'dim', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActiond); retList.push(nActiond);
                    break;
                case "verschattung_steuern": //shading_shutter
                case "rolllaeden_steuern":
                case "jalousie_steuern":
                    const nActionj = {type: 'shading_shutter', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActionj); retList.push(nActionj);
                    break;
                case "heizen_heizkoerper":
                case "heizen_fußbodenheizung":
                case "heizen_elektrisch":
                    const nActionh = {type: 'shading_shutter', uuid: getNewUuid(), device, addedIn: 'AddTaster'};
                    actions.push(nActionh); retList.push(nActionh);
                    break;
                default: break;
            }
        }
        return retList;
    }

    const checkList = [
        {key: "schaltbare_beleuchtung", onlyFirst: false, matrix: "schalten"},
        {key: "dimmbare_beleuchtung", onlyFirst: false, matrix: "dimmen"},
        {key: "steckdosen-eneg", onlyFirst: false, matrix: "schalten"},
        {key: "steckdosen-home", onlyFirst: false, matrix: "schalten"},
        {key: "heizen_fußbodenheizung", onlyFirst: true, matrix: "heizen"},
        {key: "heizen_heizkoerper", onlyFirst: true, matrix: "heizen"},
        {key: "heizen_elektrisch", onlyFirst: true, matrix: "elektrisch"},
        {key: "verschattung_steuern", onlyFirst: true, matrix: "verschatten"},
        {key: "rolllaeden_steuern", onlyFirst: true, matrix: "verschatten"},
        {key: "jalousie_steuern", onlyFirst: true, matrix: "verschatten"}
    ];
    const matrix = {
        "schalten": [
            {doorCount: 1, counter: 1, items: [{key: "1701SE", count: 1,}]},
            {doorCount: 1, counter: 2, items: [{key: "1702SE", count: 1}]},
            {doorCount: 1, counter: 3, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 1}]},
            {doorCount: 1, counter: 4, items: [{key: "1702SE", count: 2}]},
            {doorCount: 1, counter: 5, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 2}]},
            {doorCount: 1, counter: 6, items: [{key: "1702SE", count: 3}]},
            {doorCount: 1, counter: 7, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 3}]},
            {doorCount: 1, counter: 8, items: [{key: "1702SE", count: 4}]},
            {doorCount: 1, counter: 9, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 4}]},
            {doorCount: 1, counter: 10, items: [{key: "1702SE", count: 5}]},

            {doorCount: 2, counter: 1, items: [{key: "1701SE", count: 1}, {key: "1723NE-W1", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "1702SE", count: 1}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 3, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 1}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 4, items: [{key: "1702SE", count: 2}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 5, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 2}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 6, items: [{key: "1702SE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 7, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 8, items: [{key: "1702SE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 9, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 10, items: [{key: "1702SE", count: 5}, {key: "1723NE-W2", count: 2}]},

            {doorCount: 3, counter: 1, items: [{key: "1701SE", count: 1}, {key: "1723NE-W1", count: 2}]},
            {doorCount: 3, counter: 2, items: [{key: "1702SE", count: 1}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 1}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 4, items: [{key: "1702SE", count: 2}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 5, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 2}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 6, items: [{key: "1702SE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 7, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 8, items: [{key: "1702SE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 9, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 10, items: [{key: "1702SE", count: 5}, {key: "1723NE-W2", count: 2}]},

            {doorCount: 4, counter: 1, items: [{key: "1701SE", count: 1}, {key: "1723NE-W1", count: 3}]},
            {doorCount: 4, counter: 2, items: [{key: "1702SE", count: 1}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 3, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 1}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "1702SE", count: 2}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 5, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 2}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 6, items: [{key: "1702SE", count: 3}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 7, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 3}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 8, items: [{key: "1702SE", count: 4}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 9, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 4}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 10, items: [{key: "1702SE", count: 5}, {key: "1723NE-W2", count: 3}]},

            {doorCount: 5, counter: 1, items: [{key: "1701SE", count: 1}, {key: "1723NE-W1", count: 4}]},
            {doorCount: 5, counter: 2, items: [{key: "1702SE", count: 1}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 3, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 1}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 4, items: [{key: "1702SE", count: 2}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 2}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 6, items: [{key: "1702SE", count: 3}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 7, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 3}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 8, items: [{key: "1702SE", count: 4}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 9, items: [{key: "1701SE", count: 1}, {key: "1702SE", count: 4}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 10, items: [{key: "1702SE", count: 5}, {key: "1723NE-W2", count: 4}]},
        ],
        "dimmen": [
            {doorCount: 1, counter: 1, items: [{key: "1711DE", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "1712DE", count: 1}]},
            {doorCount: 1, counter: 3, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 1}]},
            {doorCount: 1, counter: 4, items: [{key: "1712DE", count: 2}]},
            {doorCount: 1, counter: 5, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 2}]},
            {doorCount: 1, counter: 6, items: [{key: "1712DE", count: 3}]},
            {doorCount: 1, counter: 7, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 3}]},
            {doorCount: 1, counter: 8, items: [{key: "1712DE", count: 4}]},
            {doorCount: 1, counter: 9, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 4}]},
            {doorCount: 1, counter: 10, items: [{key: "1712DE", count: 5}]},

            {doorCount: 2, counter: 1, items: [{key: "1711DE", count: 1}, {key: "1723NE-W1", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "1712DE", count: 1}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 3, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 1}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 4, items: [{key: "1712DE", count: 2}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 5, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 2}, {key: "1723NE-W2", count: 1}]},
            {doorCount: 2, counter: 6, items: [{key: "1712DE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 7, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 8, items: [{key: "1712DE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 9, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 2, counter: 10, items: [{key: "1712DE", count: 5}, {key: "1723NE-W2", count: 2}]},

            {doorCount: 3, counter: 1, items: [{key: "1711DE", count: 1}, {key: "1723NE-W1", count: 2}]},
            {doorCount: 3, counter: 2, items: [{key: "1712DE", count: 1}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 1}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 4, items: [{key: "1712DE", count: 2}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 5, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 2}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 6, items: [{key: "1712DE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 7, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 3}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 8, items: [{key: "1712DE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 9, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 4}, {key: "1723NE-W2", count: 2}]},
            {doorCount: 3, counter: 10, items: [{key: "1712DE", count: 5}, {key: "1723NE-W2", count: 2}]},

            {doorCount: 4, counter: 1, items: [{key: "1711DE", count: 1}, {key: "1723NE-W1", count: 3}]},
            {doorCount: 4, counter: 2, items: [{key: "1712DE", count: 1}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 3, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 1}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "1712DE", count: 2}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 5, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 2}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 6, items: [{key: "1712DE", count: 3}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 7, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 3}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 8, items: [{key: "1712DE", count: 4}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 9, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 4}, {key: "1723NE-W2", count: 3}]},
            {doorCount: 4, counter: 10, items: [{key: "1712DE", count: 5}, {key: "1723NE-W2", count: 3}]},

            {doorCount: 5, counter: 1, items: [{key: "1711DE", count: 1}, {key: "1723NE-W1", count: 4}]},
            {doorCount: 5, counter: 2, items: [{key: "1712DE", count: 1}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 3, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 1}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 4, items: [{key: "1712DE", count: 2}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 2}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 6, items: [{key: "1712DE", count: 3}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 7, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 3}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 8, items: [{key: "1712DE", count: 4}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 9, items: [{key: "1711DE", count: 1}, {key: "1712DE", count: 4}, {key: "1723NE-W2", count: 4}]},
            {doorCount: 5, counter: 10, items: [{key: "1712DE", count: 5}, {key: "1723NE-W2", count: 4}]},
        ],
        "verschatten": [
            {doorCount: 1, counter: 1, items: [{key: "1731JE", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "1731JE", count: 2}]},
            {doorCount: 1, counter: 3, items: [{key: "1731JE", count: 3}]},
            {doorCount: 1, counter: 4, items: [{key: "1731JE", count: 4}]},
            {doorCount: 1, counter: 5, items: [{key: "1731JE", count: 5}]},
            {doorCount: 1, counter: 6, items: [{key: "1731JE", count: 6}]},
            {doorCount: 2, counter: 1, items: [{key: "1731JE", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "1731JE", count: 2}]},
            {doorCount: 2, counter: 3, items: [{key: "1731JE", count: 3}]},
            {doorCount: 2, counter: 4, items: [{key: "1731JE", count: 4}]},
            {doorCount: 2, counter: 5, items: [{key: "1731JE", count: 5}]},
            {doorCount: 2, counter: 6, items: [{key: "1731JE", count: 6}]},
            {doorCount: 3, counter: 1, items: [{key: "1731JE", count: 1}]},
            {doorCount: 3, counter: 2, items: [{key: "1731JE", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "1731JE", count: 3}]},
            {doorCount: 3, counter: 4, items: [{key: "1731JE", count: 4}]},
            {doorCount: 3, counter: 5, items: [{key: "1731JE", count: 5}]},
            {doorCount: 3, counter: 6, items: [{key: "1731JE", count: 6}]},
            {doorCount: 4, counter: 1, items: [{key: "1731JE", count: 1}]},
            {doorCount: 4, counter: 2, items: [{key: "1731JE", count: 2}]},
            {doorCount: 4, counter: 3, items: [{key: "1731JE", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "1731JE", count: 4}]},
            {doorCount: 4, counter: 5, items: [{key: "1731JE", count: 5}]},
            {doorCount: 4, counter: 6, items: [{key: "1731JE", count: 6}]},
            {doorCount: 5, counter: 1, items: [{key: "1731JE", count: 1}]},
            {doorCount: 5, counter: 2, items: [{key: "1731JE", count: 2}]},
            {doorCount: 5, counter: 3, items: [{key: "1731JE", count: 3}]},
            {doorCount: 5, counter: 4, items: [{key: "1731JE", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "1731JE", count: 5}]},
            {doorCount: 5, counter: 6, items: [{key: "1731JE", count: 6}]},
        ],
        "heizen": [
            {doorCount: 1, counter: 1, items: [{key: "1790RTR", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "1790RTR", count: 2}]},
            {doorCount: 1, counter: 3, items: [{key: "1790RTR", count: 3}]},
            {doorCount: 1, counter: 4, items: [{key: "1790RTR", count: 4}]},
            {doorCount: 1, counter: 5, items: [{key: "1790RTR", count: 5}]},
            {doorCount: 1, counter: 6, items: [{key: "1790RTR", count: 6}]},
            {doorCount: 2, counter: 1, items: [{key: "1790RTR", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "1790RTR", count: 2}]},
            {doorCount: 2, counter: 3, items: [{key: "1790RTR", count: 3}]},
            {doorCount: 2, counter: 4, items: [{key: "1790RTR", count: 4}]},
            {doorCount: 2, counter: 5, items: [{key: "1790RTR", count: 5}]},
            {doorCount: 2, counter: 6, items: [{key: "1790RTR", count: 6}]},
            {doorCount: 3, counter: 1, items: [{key: "1790RTR", count: 1}]},
            {doorCount: 3, counter: 2, items: [{key: "1790RTR", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "1790RTR", count: 3}]},
            {doorCount: 3, counter: 4, items: [{key: "1790RTR", count: 4}]},
            {doorCount: 3, counter: 5, items: [{key: "1790RTR", count: 5}]},
            {doorCount: 3, counter: 6, items: [{key: "1790RTR", count: 6}]},
            {doorCount: 4, counter: 1, items: [{key: "1790RTR", count: 1}]},
            {doorCount: 4, counter: 2, items: [{key: "1790RTR", count: 2}]},
            {doorCount: 4, counter: 3, items: [{key: "1790RTR", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "1790RTR", count: 4}]},
            {doorCount: 4, counter: 5, items: [{key: "1790RTR", count: 5}]},
            {doorCount: 4, counter: 6, items: [{key: "1790RTR", count: 6}]},
            {doorCount: 5, counter: 1, items: [{key: "1790RTR", count: 1}]},
            {doorCount: 5, counter: 2, items: [{key: "1790RTR", count: 2}]},
            {doorCount: 5, counter: 3, items: [{key: "1790RTR", count: 3}]},
            {doorCount: 5, counter: 4, items: [{key: "1790RTR", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "1790RTR", count: 5}]},
            {doorCount: 5, counter: 6, items: [{key: "1790RTR", count: 6}]},
        ],
        "elektrisch": [
            {doorCount: 1, counter: 1, items: [{key: "elektrisch", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "elektrisch", count: 2}]},
            {doorCount: 1, counter: 3, items: [{key: "elektrisch", count: 3}]},
            {doorCount: 1, counter: 4, items: [{key: "elektrisch", count: 4}]},
            {doorCount: 1, counter: 5, items: [{key: "elektrisch", count: 5}]},
            {doorCount: 1, counter: 6, items: [{key: "elektrisch", count: 6}]},
            {doorCount: 2, counter: 1, items: [{key: "elektrisch", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "elektrisch", count: 2}]},
            {doorCount: 2, counter: 3, items: [{key: "elektrisch", count: 3}]},
            {doorCount: 2, counter: 4, items: [{key: "elektrisch", count: 4}]},
            {doorCount: 2, counter: 5, items: [{key: "elektrisch", count: 5}]},
            {doorCount: 2, counter: 6, items: [{key: "elektrisch", count: 6}]},
            {doorCount: 3, counter: 1, items: [{key: "elektrisch", count: 1}]},
            {doorCount: 3, counter: 2, items: [{key: "elektrisch", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "elektrisch", count: 3}]},
            {doorCount: 3, counter: 4, items: [{key: "elektrisch", count: 4}]},
            {doorCount: 3, counter: 5, items: [{key: "elektrisch", count: 5}]},
            {doorCount: 3, counter: 6, items: [{key: "elektrisch", count: 6}]},
            {doorCount: 4, counter: 1, items: [{key: "elektrisch", count: 1}]},
            {doorCount: 4, counter: 2, items: [{key: "elektrisch", count: 2}]},
            {doorCount: 4, counter: 3, items: [{key: "elektrisch", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "elektrisch", count: 4}]},
            {doorCount: 4, counter: 5, items: [{key: "elektrisch", count: 5}]},
            {doorCount: 4, counter: 6, items: [{key: "elektrisch", count: 6}]},
            {doorCount: 5, counter: 1, items: [{key: "elektrisch", count: 1}]},
            {doorCount: 5, counter: 2, items: [{key: "elektrisch", count: 2}]},
            {doorCount: 5, counter: 3, items: [{key: "elektrisch", count: 3}]},
            {doorCount: 5, counter: 4, items: [{key: "elektrisch", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "elektrisch", count: 5}]},
            {doorCount: 5, counter: 6, items: [{key: "elektrisch", count: 6}]},
        ]
    };
    const matrix_umbau_de = {
        "schalten": [
            {doorCount: 1, counter: 1, items: [{key: "BTPSE1B2U", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "BTPS2B2U", count: 1}]},
            {doorCount: 1, counter: 3, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 1}]},
            {doorCount: 1, counter: 4, items: [{key: "BTPS2B2U", count: 2}]},
            {doorCount: 1, counter: 5, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 2}]},
            {doorCount: 1, counter: 6, items: [{key: "BTPS2B2U", count: 3}]},

            {doorCount: 2, counter: 1, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPB2U", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 1}]},
            {doorCount: 2, counter: 3, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 1}]},
            {doorCount: 2, counter: 4, items: [{key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 1}]},
            {doorCount: 2, counter: 5, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 1}]},
            {doorCount: 2, counter: 6, items: [{key: "BTPS2B2U", count: 3}, {key: "BTPB2U", count: 1}]},

            {doorCount: 3, counter: 1, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPB2U", count: 2}]},
            {doorCount: 3, counter: 2, items: [{key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 2}]},
            {doorCount: 3, counter: 4, items: [{key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 2}]},
            {doorCount: 3, counter: 5, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 2}]},
            {doorCount: 3, counter: 6, items: [{key: "BTPS2B2U", count: 3}, {key: "BTPB2U", count: 2}]},

            {doorCount: 4, counter: 1, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPB2U", count: 3}]},
            {doorCount: 4, counter: 2, items: [{key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 3}]},
            {doorCount: 4, counter: 3, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 3}]},
            {doorCount: 4, counter: 5, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 3}]},
            {doorCount: 4, counter: 6, items: [{key: "BTPS2B2U", count: 3}, {key: "BTPB2U", count: 3}]},

            {doorCount: 5, counter: 1, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPB2U", count: 4}]},
            {doorCount: 5, counter: 2, items: [{key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 4}]},
            {doorCount: 5, counter: 3, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 1}, {key: "BTPB2U", count: 4}]},
            {doorCount: 5, counter: 4, items: [{key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "BTPSE1B2U", count: 1}, {key: "BTPS2B2U", count: 2}, {key: "BTPB2U", count: 4}]},
            {doorCount: 5, counter: 6, items: [{key: "BTPS2B2U", count: 3}, {key: "BTPB2U", count: 4}]},
        ],
        "heizen": [
            {doorCount: 1, counter: 1, items: [{key: "HP1", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "HP2", count: 2}]},
            {doorCount: 1, counter: 3, items: [{key: "HP3", count: 3}]},
            {doorCount: 1, counter: 4, items: [{key: "HP4", count: 4}]},
            {doorCount: 1, counter: 5, items: [{key: "HP5", count: 5}]},
            {doorCount: 1, counter: 6, items: [{key: "HP6", count: 6}]},

            {doorCount: 2, counter: 1, items: [{key: "HP1", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "HP2", count: 2}]},
            {doorCount: 2, counter: 3, items: [{key: "HP3", count: 3}]},
            {doorCount: 2, counter: 4, items: [{key: "HP4", count: 4}]},
            {doorCount: 2, counter: 5, items: [{key: "HP5", count: 5}]},
            {doorCount: 2, counter: 6, items: [{key: "HP6", count: 6}]},

            {doorCount: 3, counter: 1, items: [{key: "HP1", count: 1}]},
            {doorCount: 3, counter: 2, items: [{key: "HP2", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "HP3", count: 3}]},
            {doorCount: 3, counter: 4, items: [{key: "HP4", count: 4}]},
            {doorCount: 3, counter: 5, items: [{key: "HP5", count: 5}]},
            {doorCount: 3, counter: 6, items: [{key: "HP6", count: 6}]},

            {doorCount: 4, counter: 1, items: [{key: "HP1", count: 1}]},
            {doorCount: 4, counter: 2, items: [{key: "HP2", count: 2}]},
            {doorCount: 4, counter: 3, items: [{key: "HP3", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "HP4", count: 4}]},
            {doorCount: 4, counter: 5, items: [{key: "HP5", count: 5}]},
            {doorCount: 4, counter: 6, items: [{key: "HP6", count: 6}]},

            {doorCount: 5, counter: 1, items: [{key: "HP1", count: 1}]},
            {doorCount: 5, counter: 2, items: [{key: "HP2", count: 2}]},
            {doorCount: 5, counter: 3, items: [{key: "HP3", count: 3}]},
            {doorCount: 5, counter: 4, items: [{key: "HP4", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "HP5", count: 5}]},
            {doorCount: 5, counter: 6, items: [{key: "HP6", count: 6}]},
        ],
        "dimmen": [
            {doorCount: 1, counter: 1, items: [{key: "DIMPUK", count: 1}]},
            {doorCount: 1, counter: 2, items: [{key: "DIMPUK", count: 2}]},
            {doorCount: 1, counter: 3, items: [{key: "DIMPUK", count: 3}]},
            {doorCount: 1, counter: 4, items: [{key: "DIMPUK", count: 4}]},
            {doorCount: 1, counter: 5, items: [{key: "DIMPUK", count: 5}]},
            {doorCount: 1, counter: 6, items: [{key: "DIMPUK", count: 6}]},

            {doorCount: 2, counter: 1, items: [{key: "DIMPUK", count: 1}]},
            {doorCount: 2, counter: 2, items: [{key: "DIMPUK", count: 2}]},
            {doorCount: 2, counter: 3, items: [{key: "DIMPUK", count: 3}]},
            {doorCount: 2, counter: 4, items: [{key: "DIMPUK", count: 4}]},
            {doorCount: 2, counter: 5, items: [{key: "DIMPUK", count: 5}]},
            {doorCount: 2, counter: 6, items: [{key: "DIMPUK", count: 6}]},

            {doorCount: 3, counter: 1, items: [{key: "DIMPUK", count: 1}]},
            {doorCount: 3, counter: 2, items: [{key: "DIMPUK", count: 2}]},
            {doorCount: 3, counter: 3, items: [{key: "DIMPUK", count: 3}]},
            {doorCount: 3, counter: 4, items: [{key: "DIMPUK", count: 4}]},
            {doorCount: 3, counter: 5, items: [{key: "DIMPUK", count: 5}]},
            {doorCount: 3, counter: 6, items: [{key: "DIMPUK", count: 6}]},

            {doorCount: 4, counter: 1, items: [{key: "DIMPUK", count: 1}]},
            {doorCount: 4, counter: 2, items: [{key: "DIMPUK", count: 2}]},
            {doorCount: 4, counter: 3, items: [{key: "DIMPUK", count: 3}]},
            {doorCount: 4, counter: 4, items: [{key: "DIMPUK", count: 4}]},
            {doorCount: 4, counter: 5, items: [{key: "DIMPUK", count: 5}]},
            {doorCount: 4, counter: 6, items: [{key: "DIMPUK", count: 6}]},

            {doorCount: 5, counter: 1, items: [{key: "DIMPUK", count: 1}]},
            {doorCount: 5, counter: 2, items: [{key: "DIMPUK", count: 2}]},
            {doorCount: 5, counter: 3, items: [{key: "DIMPUK", count: 3}]},
            {doorCount: 5, counter: 4, items: [{key: "DIMPUK", count: 4}]},
            {doorCount: 5, counter: 5, items: [{key: "DIMPUK", count: 5}]},
            {doorCount: 5, counter: 6, items: [{key: "DIMPUK", count: 6}]},
        ],
    };
    const produkte = {
        "1701SE": ["scha-einsatz-1", "scha-aufsatz-1"],
        "1702SE": ["scha-einsatz-2", "scha-aufsatz-2"],
        "1731JE": ["versch-einsatz", "versch-aufsatz"],
        "1790RTR": ["heiz-einsatz", "heiz-aufsatz-2", "rt-ventil-1"],
        "1711DE": ["dimmer-eins-univ", "scha-aufsatz-1"],
        "1712DE": ["serien-dimmer-eins-univ", "scha-aufsatz-2"],
        "1723NE-W1": ["nebenstelle", "scha-aufsatz-1"],
        "1723NE-W2": ["nebenstelle", "scha-aufsatz-2"],
        "elektrisch": ["nebenstelle", "home-puck", "heiz-aufsatz-2", "heiz-einsatz"],
        "HP1": ["home-puck", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "HP2": ["home-puck-2", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "HP3": ["home-puck", "home-puck-2", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "HP4": ["home-puck-2", "home-puck-2", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "HP5": ["home-puck", "home-puck-2", "home-puck-2", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "HP6": ["home-puck-2", "home-puck-2", "home-puck-2", "heiz-aufsatz-2", "nebenstelle", "rt-ventil-1" ],
        "DIMPUK": ["dim-puck", "puk-einsatz", "puk-aufsatz" ],
        "BTPSE1B2U": ["home-puck", "puk-einsatz", "puk-aufsatz" ],
        "BTPS2B2U": ["home-puck-2", "puk-einsatz", "puk-aufsatz" ],
        "BTPB2U": ["home-puck-3", "puk-einsatz", "puk-aufsatz" ],
    };
    if (lang === 'de' && subProjectType === 'umbau') {
        matrix['heizen'] = matrix_umbau_de['heizen'];
        matrix['dimmen'] = matrix_umbau_de['dimmen'];
        matrix['schalten'] = matrix_umbau_de['schalten'];
        produkte["1731JE"] = ["jalousieaktor", "puk-einsatz", "puk-aufsatz-jalousie"];
    }
    let requiredFrames = 0; let requiredFrames_schalten_dimmen = 0;
    let normalHeating = 0; let electricHeating = 0; let rahmenHeating = 0; let rahmenEHeating = 0;
    checkList.forEach(item => {
        if(room.selectedEquipment[item.key] !== undefined && room.selectedEquipment[item.key] > 0){
            const mItems = matrix[item.matrix].filter(i => i.doorCount === room.doorCount);
            const max = matrix[item.matrix].filter(i => i.doorCount === room.doorCount && (i.counter === (['schalten','dimmen'].includes(item.matrix)?10:6)))[0];
            let required = room.selectedEquipment[item.key]; let requiredTermostat = required;
            if (item.matrix === 'verschatten') { required = room.windowCount; }
            else if (item.matrix === 'heizen') {
                requiredTermostat = 0;
                if (room.selectedEquipment[item.key] > 0) { requiredTermostat = normalHeating > 0 ? 0 : 1; rahmenHeating = normalHeating > 0 ? 0 : 1; normalHeating += 1; }
                required = item.key === "heizen_heizkoerper" ? room.heatingCount : room.floorheatingCount;
            }
            else if (item.matrix === 'elektrisch') {
                requiredTermostat = 0;
                if (room.selectedEquipment[item.key] > 0) { requiredTermostat = electricHeating > 0 ? 0 : 1; rahmenEHeating = electricHeating > 0 ? 0 : 1; electricHeating += 1; }
                required = 1;
            }

            const c = Math.floor(required / (['schalten','dimmen'].includes(item.matrix)?10:6));
            console.log('c is', c, 'required is', required, )
            for(let i = 0; i < c; i++) {
                // eslint-disable-next-line
                max.items.forEach(mItem => {
                    let cp = [];
                    produkte[mItem.key].forEach((p, pIdx) => {
                        if (pIdx < 1) {
                            const dActions = addActionForDevice(austattung_produkt[p], item, mItem.count);
                            productList.push({
                                product: austattung_produkt[p],
                                count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                                actions: dActions.map(i => i.uuid)
                            });
                            if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                        } else if (pIdx < 2) {
                            productList.push({
                                product: austattung_produkt[p],
                                count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                            });
                            if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                        } else if (pIdx < produkte[mItem.key].length - 1 && lang === 'de' && subProjectType === 'umbau') {
                            if ((item.matrix === 'heizen' && normalHeating < 2) || item.matrix !== 'heizen') {
                                productList.push({
                                    product: austattung_produkt[p],
                                    count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                                });
                                if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                            }
                        } else {
                            productList.push({
                                product: austattung_produkt[p],
                                count: mItem.count,
                            });
                            if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], mItem.count); }
                            productList_optional.push({product: austattung_produkt[p], count: mItem.count});
                        }
                        cp.push(austattung_produkt[p]);
                    });
                    for ( let k = 0; k < mItem.count; k++ ) {
                        if (['schalten','dimmen'].includes(item.matrix)) { combinations.producte_sch_d.push(cp); }
                        else { combinations.producte.push(cp); }
                    }
                    requiredFrames += ['schalten','dimmen'].includes(item.matrix) ? 0 : (item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count);
                    requiredFrames_schalten_dimmen += ['schalten','dimmen'].includes(item.matrix) ? mItem.count : 0;
                    console.log('requiredFrames', requiredFrames);
                });
            }
            required -= c * (['schalten','dimmen'].includes(item.matrix)?10:6);
            if (c > 0 && (item.matrix === "heizen" || item.matrix === 'elektrisch')) { requiredTermostat = 0; }
            const toPush = mItems.filter(i => i.counter === required)[0];
            console.log('required is', required, 'toPush is', toPush)
            console.log('normalheating', normalHeating, electricHeating, toPush, mItems, 'required', required)
            if (toPush) {
                toPush.items.forEach(mItem => {
                    let cp = [];
                    produkte[mItem.key].forEach((p, pIdx) => {
                        if (pIdx < 1) {
                            if ((item.matrix === 'heizen' && normalHeating < 2) || item.matrix !== 'heizen') {
                                const dActions = addActionForDevice(austattung_produkt[p], item, mItem.count);
                                productList.push({
                                    product: austattung_produkt[p],
                                    count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                                    actions: dActions.map(i => i.uuid)
                                });
                                if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                            }
                        } else if (pIdx < 2) {
                            if ((item.matrix === 'heizen' && normalHeating < 2) || item.matrix !== 'heizen') {
                                productList.push({
                                    product: austattung_produkt[p],
                                    count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                                });
                                if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                            }
                        } else if (pIdx < produkte[mItem.key].length - 1 && lang === 'de' && subProjectType === 'umbau') {
                            if ((item.matrix === 'heizen' && normalHeating < 2) || item.matrix !== 'heizen') {
                                productList.push({
                                    product: austattung_produkt[p],
                                    count: item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count,
                                });
                                if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], item.matrix === 'heizen' || item.matrix === 'elektrisch' ? requiredTermostat : mItem.count); }
                            }
                        } else {
                            if (item.matrix === 'elektrisch') {
                                if (normalHeating === 0) {
                                    productList.push({
                                        product: austattung_produkt[p],
                                        count: 1,
                                    });
                                    if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], 1); }
                                }
                            } else {
                                productList.push({
                                    product: austattung_produkt[p],
                                    count: mItem.count,
                                });
                                productList_optional.push({product: austattung_produkt[p], count: mItem.count});
                                if (item.matrix === 'heizen' || item.matrix === 'elektrisch') { console.log('pushed', pIdx, austattung_produkt[p], mItem.count); }
                            }
                        }
                        cp.push(austattung_produkt[p]);
                    });
                    for ( let k = 0; k < mItem.count; k++ ) {
                        if (['schalten','dimmen'].includes(item.matrix)) { combinations.producte_sch_d.push(cp); }
                        else { combinations.producte.push(cp); }
                    }
                    requiredFrames += ['schalten','dimmen'].includes(item.matrix) ? 0 : (item.matrix === 'heizen' || item.matrix === 'elektrisch' ? (normalHeating < 2 ? requiredTermostat : 0) : mItem.count);
                    requiredFrames_schalten_dimmen += ['schalten','dimmen'].includes(item.matrix) ? mItem.count : 0;
                    // console.log('requiredFrames', requiredFrames);
                });
            }
        }
    });
    // console.log('requiredFrames', requiredFrames, 'requiredFrames_schalten_dimmen', requiredFrames_schalten_dimmen);
    // console.log('combinations', {...combinations});

    const frames = [];
    if (austattung_produkt["r-5f"] !== "") { frames.push({key: "r-5f", counter: 5}); }
    if (austattung_produkt["r-4f"] !== "") { frames.push({key: "r-4f", counter: 4}); }
    if (austattung_produkt["r-3f"] !== "") { frames.push({key: "r-3f", counter: 3}); }
    if (austattung_produkt["r-2f"] !== "") { frames.push({key: "r-2f", counter: 2}); }
    if (austattung_produkt["r-1f"] !== "") { frames.push({key: "r-1f", counter: 1}); }
// console.log('before addframes', {...combinations})
    console.log('before adding frames - required frames', requiredFrames, 'required schalten, dimmen', requiredFrames_schalten_dimmen);
    const addFrames = function(is_sch_dim = false, oneFrame = false) {
        frames.forEach(frame => {
            const c = Math.floor((is_sch_dim ? requiredFrames_schalten_dimmen : (rahmenHeating + rahmenEHeating)) / (is_sch_dim ? room.doorCount : (rahmenHeating + rahmenEHeating)) / frame.counter);
            if (c > 0) {
                if (is_sch_dim) {requiredFrames_schalten_dimmen -= c * frame.counter * (is_sch_dim ? room.doorCount : 1); }
                else { requiredFrames -= c * frame.counter * (is_sch_dim ? room.doorCount : (rahmenHeating + rahmenEHeating)); }
                productList.push({
                    product: austattung_produkt[frame.key],
                    count: c * (is_sch_dim ? room.doorCount : 1)
                });
                rahmenHeating -= frame.counter;
                console.log('rahmenHeating', rahmenHeating, rahmenEHeating, 'requiredFrames', requiredFrames)
                console.log('pushed frame', c, c * (is_sch_dim ? room.doorCount : requiredFrames), frame)
                if (c * (is_sch_dim ? room.doorCount : requiredFrames) > 0) {
                    for (let i = 0; i < c * (is_sch_dim ? room.doorCount : requiredFrames); i++) {
                        let position = 1;
                        let comb = {
                            frame: austattung_produkt[frame.key],
                            factor: 1,
                            orientation: 'V',
                            controlElements: [],
                            origin: 'addTaster, 373'
                        };
                        for (let j = 0; j < frame.counter; j++) {
                            const prods = is_sch_dim ? combinations.producte_sch_d.shift() : combinations.producte.shift();
                            // console.log('prods', prods, is_sch_dim, combinations)
                            let controlEl = {
                                position: position,
                                insert: prods[0]
                            };
                            if (prods.length > 1) {
                                controlEl.abdeckung = prods[1];
                            }
                            // if (prods.length > 2) { controlEl.abdeckungDesign = prods[2]; }
                            comb.controlElements.push(controlEl);
                            position += 1;
                        }
                        combinations.combinations.push(comb);
                        // console.log('pushed combination', comb, i, c, frame)
                    }
                }
            }
        });
        if (oneFrame && (is_sch_dim ? requiredFrames_schalten_dimmen > 0 : requiredFrames > 0)) {
            productList.push({
                product: austattung_produkt["r-1f"],
                count: is_sch_dim ? requiredFrames_schalten_dimmen : requiredFrames
            });
            console.log('pushed frame', is_sch_dim ? requiredFrames_schalten_dimmen : requiredFrames, {key:'r-1f',counter:1})
            for (let j = 0; j < (is_sch_dim ? requiredFrames_schalten_dimmen : requiredFrames); j++) {
                let comb = {
                    frame: austattung_produkt["r-1f"],
                    factor: 1,
                    orientation: 'V',
                    controlElements: [],
                    origin: 'addTaster, 404'
                };
                const prods = is_sch_dim ? combinations.producte_sch_d.shift() : combinations.producte.shift();
                // console.log('oneframe prods', prods)
                if (prods) {
                    let controlEl = {
                        position: 1,
                        insert: prods[0]
                    };
                    if (prods.length > 1) {
                        controlEl.abdeckung = prods[1];
                    }
                    // if (prods.length > 2) { controlEl.abdeckungDesign = prods[2]; }
                    comb.controlElements.push(controlEl);
                    combinations.combinations.push(comb);
                }
                // console.log('pushed combination', comb, is_sch_dim ? requiredFrames_schalten_dimmen : requiredFrames, {key:'r-1f',counter:1})
            }
        }
    }

    addFrames(false, false);
    if (requiredFrames > 0) { addFrames(false, true); }

    addFrames(true, false);
    if (requiredFrames_schalten_dimmen > 0) { addFrames(true, true); }
// console.log('after addframes', combinations)
    console.log('room', room, 'ausstattung', austattung_produkt, productList, actions, combinations, productList_optional)
    return {list: productList, actions, combinations, productList_optional};
}

